import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { SharedService } from '../../shared/shared.service';
import { ConfirmationDeactivateService } from '../../shared/ConfirmationDeactivateModule/confirmationdeactivate.service';
import { TranslatedNotificationService } from '../../shared/translation/translated-notification.service';

import { Division, Language, UserDetailsDto } from '../../shared/model';

import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { Router } from "@angular/router"

@Component({
  templateUrl: './headed.component.html',
  styleUrls: ['./headed.component.css']
})
export class HeadedComponent implements OnInit {
  public loggedUser: UserDetailsDto = <UserDetailsDto>{
    FirstName: '',
    LastName: ''
  };

  
  public userInitials: string;
  public userEmail: string;
  public allLanguages: Array<Language>;
  public selectedLanguage: Language = <Language>{};

  private currentLanguage: Language = <Language>{};

  constructor(
    private vRef: ViewContainerRef,
    private sharedService: SharedService,
    private notificationService: TranslatedNotificationService,
    private confirmationDeactivateService: ConfirmationDeactivateService,
    private router: Router) {
    this.confirmationDeactivateService.setRootViewContainerRef(this.vRef);
  }

  ngOnInit() {
    this.sharedService.getUserDetails().subscribe(
      data => {
        this.loggedUser.FirstName = data.FirstName;
        this.loggedUser.LastName = data.LastName;
        this.loggedUser.Email = data.Email;
        this.loggedUser.UserRole = data.UserRole;
        this.loggedUser.Division = data.Division;
        if (this.loggedUser.Division == Division.ConditionsNotFulfilled) {
          this.router.navigate(['/no-division-page'])
        }
      },
      () => {
        this.notificationService.showMsgError('error.loading_user_data', 'Error while loading user data');
      }
    );

    let localstorageLanguage = localStorage.getItem('currLanguage');
    if (localstorageLanguage !== undefined && localstorageLanguage !== 'undefined' && localstorageLanguage !== null) {
      this.currentLanguage = JSON.parse(localstorageLanguage);
    } else {
      this.currentLanguage = null;
    }

    this.sharedService.getLanguages().subscribe((result) => {
      this.allLanguages = result;
      if (this.currentLanguage !== null) {
        this.selectedLanguage = this.currentLanguage;
      } else {
        this.selectedLanguage = this.allLanguages.find(x => x.Name === 'English');
      }
      this.sharedService.setCurrentLanguage(this.selectedLanguage);
      forkJoin(
        [this.sharedService.getLanguagesTranslations(),
        this.sharedService.getCategoryTranslations()])
        .subscribe(() => { });
    },
      () => {
        this.notificationService
          .showMsgError('error.loading_language_definitions', 'Error while loading languages definitions.');
      });
  }


}
